import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=ffb1fc32&scoped=true"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"
import style0 from "./Loja.vue?vue&type=style&index=0&id=ffb1fc32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb1fc32",
  null
  
)

export default component.exports